export default __webpack_public_path__ + "7cc5e1c61e40a3b95e834df68558aea2.png";